module.exports = __webpack_public_path__ + "img/chatdata表格解析工具.60e7b963.gif";